import * as React from 'react';
import '../../../panels/panels.css';
import { Button, Label, Segment, Form, Dropdown, Input, Radio, Checkbox, Icon, Header, Modal } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Toast from '../../../sys/toast';
import OAuth, { OAuthClientStatus } from '../../../api';

class State {
    vodMode: string; vodSchStartTime: number; vodSchDuration: number; vodSchSwitchbackImmediate: boolean; vodPartialBegin: number;
    vodPartialMiddle: number; vodPartialEnd: number; vodVariantMax: number; vodAssetMax: number; vodTimeoutOutage: number;
    vodTimeoutAdvance: number; vodTimeoutFullDev: number; vodDurDev: number; timeoutHelpModalOpen?: boolean;
}

interface Props {

}

export default class VODConfig extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            vodMode: '', vodSchStartTime: 0, vodSchDuration: 0, vodSchSwitchbackImmediate: false, vodPartialBegin: 0,
            vodPartialMiddle: 0, vodPartialEnd: 0, vodVariantMax: 0, vodAssetMax: 0, vodTimeoutOutage: 0, vodTimeoutAdvance: 0,
            vodTimeoutFullDev: 0, vodDurDev: 0, timeoutHelpModalOpen: false
        });

        this.fetchData();
        this.setTimeoutHelpModalOpen = this.setTimeoutHelpModalOpen.bind(this);
    }

    fetchData() {
        let _this = this;
        let url = 'http://default/api/config/section/options/abr';

        axios.post(url, {
            mode: 'get',
            defaults: {
            },
            options: [
                'vodMode', 'vodSchStartTime', 'vodSchDuration', 'vodPartialBegin', 'vodPartialMiddle', 'vodPartialEnd',
                'vodVariantMax', 'vodAssetMax', 'vodTimeoutOutage', 'vodTimeoutAdvance', 'vodTimeoutFullDev', 'vodDurDev', 'vodSchSwitchbackImmediate'
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;

                    _this.setState({
                        vodMode: responseObject[0].value, vodSchStartTime: responseObject[1].value, vodSchDuration: responseObject[2].value,
                        vodPartialBegin: responseObject[3].value, vodPartialMiddle: responseObject[4].value, vodPartialEnd: responseObject[5].value,
                        vodVariantMax: responseObject[6].value, vodAssetMax: responseObject[7].value, vodTimeoutOutage: responseObject[8].value,
                        vodTimeoutAdvance: responseObject[9].value, vodTimeoutFullDev: responseObject[10].value, vodDurDev: responseObject[11].value,
                        vodSchSwitchbackImmediate: responseObject[12].value
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });

    }

    updateConfig(e: any, data: any, limit?: any) {
        let _this = this;
        let max = limit > 64 ? 64 : limit;

        let url = 'http://default/api/config/section/options/abr';

        let options = [
            { 'name': 'vodMode', 'value': this.state.vodMode },
            { 'name': 'vodSchStartTime', 'value': this.state.vodSchStartTime },
            { 'name': 'vodSchDuration', 'value': this.state.vodSchDuration },
            { 'name': 'vodSchSwitchbackImmediate', 'value': this.state.vodSchSwitchbackImmediate },
            { 'name': 'vodPartialBegin', 'value': this.state.vodPartialBegin },
            { 'name': 'vodPartialMiddle', 'value': this.state.vodPartialMiddle },
            { 'name': 'vodPartialEnd', 'value': this.state.vodPartialEnd },
            { 'name': 'vodVariantMax', 'value': this.state.vodVariantMax > max ? max : this.state.vodVariantMax },
            { 'name': 'vodAssetMax', 'value': this.state.vodAssetMax },
            { 'name': 'vodTimeoutOutage', 'value': this.state.vodTimeoutOutage },
            { 'name': 'vodTimeoutAdvance', 'value': this.state.vodTimeoutAdvance },
            { 'name': 'vodTimeoutFullDev', 'value': this.state.vodTimeoutFullDev },
            { 'name': 'vodDurDev', 'value': this.state.vodDurDev }
            ];

        axios.post(url, {
            mode: 'modify',
            defaults: {
            },
            options: options
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    Toast.info('VOD configuration applied');
                    _this.fetchData();
                } else {
                    Toast.error('Failed to update VOD Diagnostics configuration');
                    Toast.error('Error: ' + response.data.det);
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('updateConfig() error: ', error);
                Toast.error('Failed to update VOD Diagnostics configuration');
            });
    }

    setVariantMax(event: any, limit: any, data?: any) {
        let max = limit > 64 ? 64 : limit;
        if (data) {
            if (data.value > max) {
                this.setState({vodVariantMax: max});
            } else {
                this.setState({vodVariantMax: data.value});
            }
        }
    }

    // Set the Timeout help Modal to open/closed
    setTimeoutHelpModalOpen(isOpen: boolean) {
        this.setState({timeoutHelpModalOpen: isOpen});
    }

    render() {

        const vodSchStartTimeOptions = [
            {text: '00:00', value: 0}, {text: '00:15', value: 1}, {text: '00:30', value: 2}, {text: '00:45', value: 3},
            {text: '01:00', value: 4}, {text: '01:15', value: 5}, {text: '01:30', value: 6}, {text: '01:45', value: 7},
            {text: '02:00', value: 8}, {text: '02:15', value: 9}, {text: '02:30', value: 10}, {text: '02:45', value: 11},
            {text: '03:00', value: 12}, {text: '03:15', value: 13}, {text: '03:30', value: 14}, {text: '03:45', value: 15},
            {text: '04:00', value: 16}, {text: '04:15', value: 17}, {text: '04:30', value: 18}, {text: '04:45', value: 19},
            {text: '05:00', value: 20}, {text: '05:15', value: 21}, {text: '05:30', value: 22}, {text: '05:45', value: 23},
            {text: '06:00', value: 24}, {text: '06:15', value: 25}, {text: '06:30', value: 26}, {text: '06:45', value: 27},
            {text: '07:00', value: 28}, {text: '07:15', value: 29}, {text: '07:30', value: 30}, {text: '07:45', value: 31},
            {text: '08:00', value: 32}, {text: '08:15', value: 33}, {text: '08:30', value: 34}, {text: '08:45', value: 35},
            {text: '09:00', value: 36}, {text: '09:15', value: 37}, {text: '09:30', value: 38}, {text: '09:45', value: 39},
            {text: '10:00', value: 40}, {text: '10:15', value: 41}, {text: '10:30', value: 42}, {text: '10:45', value: 43},
            {text: '11:00', value: 44}, {text: '11:15', value: 45}, {text: '11:30', value: 46}, {text: '11:45', value: 47},
            {text: '12:00', value: 48}, {text: '12:15', value: 49}, {text: '12:30', value: 50}, {text: '12:45', value: 51},
            {text: '13:00', value: 52}, {text: '13:15', value: 53}, {text: '13:30', value: 54}, {text: '13:45', value: 55},
            {text: '14:00', value: 56}, {text: '14:15', value: 57}, {text: '14:30', value: 58}, {text: '14:45', value: 59},
            {text: '15:00', value: 60}, {text: '15:15', value: 61}, {text: '15:30', value: 62}, {text: '15:45', value: 63},
            {text: '16:00', value: 64}, {text: '16:15', value: 65}, {text: '16:30', value: 66}, {text: '16:45', value: 67},
            {text: '17:00', value: 68}, {text: '17:15', value: 69}, {text: '17:30', value: 70}, {text: '17:45', value: 71},
            {text: '18:00', value: 72}, {text: '18:15', value: 73}, {text: '18:30', value: 74}, {text: '18:45', value: 75},
            {text: '19:00', value: 76}, {text: '19:15', value: 77}, {text: '19:30', value: 78}, {text: '19:45', value: 79},
            {text: '20:00', value: 80}, {text: '20:15', value: 81}, {text: '20:30', value: 82}, {text: '20:45', value: 83},
            {text: '21:00', value: 84}, {text: '21:15', value: 85}, {text: '21:30', value: 86}, {text: '21:45', value: 87},
            {text: '22:00', value: 88}, {text: '22:15', value: 89}, {text: '22:30', value: 90}, {text: '22:45', value: 91},
            {text: '23:00', value: 92}, {text: '23:15', value: 93}, {text: '23:30', value: 94}, {text: '23:45', value: 95},
        ];
        return (
            <OAuth.Context>
                {(oauth: OAuthClientStatus) => {
                    return (
                    <React.Fragment>
                        <div className="assetAliasFilters">
                            <Label className="system-config-pageHeader">
                                Video On Demand
                            </Label>
                            <Button
                                floated="right"
                                className="rightButton"
                                content="Apply"
                                title="Update Config"
                                onClick={(e, data) => this.updateConfig(e, data, oauth.sys.licenseFlowLimit)}
                            />
                        </div>

                        <div className="vertical-flex-main">
                            <Segment.Group className="system-config-segment">
                                <Segment className="segment-header">Operation</Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Disable
                                            </Label>
                                            <Radio
                                                name="radioGroup"
                                                value="disable"
                                                checked={this.state.vodMode === 'disable'}
                                                onChange={(e: any, data: any) => this.setState({vodMode: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Continuous
                                            </Label>
                                            <Radio
                                                name="radioGroup"
                                                value="continuous"
                                                checked={this.state.vodMode === 'continuous'}
                                                onChange={(e: any, data: any) => this.setState({vodMode: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Schedule
                                            </Label>
                                            <Radio
                                                name="radioGroup"
                                                value="schedule"
                                                checked={this.state.vodMode === 'schedule'}
                                                onChange={(e: any, data: any) => this.setState({vodMode: data.value})}
                                            />
                                        </Form.Group>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="right-align-label400-smallFont">
                                                    Start Time ({oauth.sys ? oauth.sys.tz : '-'})
                                                </Label>
                                                <Dropdown
                                                    search
                                                    disabled={!(this.state.vodMode === 'schedule')}
                                                    className="dropDown"
                                                    selection
                                                    options={vodSchStartTimeOptions}
                                                    value={this.state.vodSchStartTime}
                                                    onChange={(event: any, data: any) => this.setState({vodSchStartTime: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label400-smallFont">
                                                    Duration (minutes)
                                                </Label>
                                                <Input
                                                    type="number"
                                                    disabled={!(this.state.vodMode === 'schedule')}
                                                    min="60"
                                                    max="720"
                                                    value={this.state.vodSchDuration}
                                                    onChange={(e: any, data: any) => this.setState({vodSchDuration: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label400-smallFont">
                                                    Switchback Immediate
                                                </Label>
                                                <Checkbox
                                                    className="config-checkbox"
                                                    checked={this.state.vodSchSwitchbackImmediate}
                                                    onChange={(e: any, data: any) => this.setState({vodSchSwitchbackImmediate: data.checked})}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Form>
                                </Segment>
                                <Segment className="segment-header">Monitoring Limits</Segment>
                                <Segment>
                                    <Form>
                                        <span>
                                            <p>Configure the maximum number of assets to test simultaneously. This is one mechanism to control
                                            the testing load on VOD resources. Configuring the maximum number of variants per VOD asset enables
                                            the probe to reserve resources and ensure monitoring capacity is not exceeded.
                                            </p><br />
                                        </span>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Maximum variants per asset
                                            </Label>
                                            <Input
                                                type="number"
                                                min="1"
                                                max={oauth.sys.licenseFlowLimit ? oauth.sys.licenseFlowLimit > 64 ? 64 : oauth.sys.licenseFlowLimit : 64}
                                                value={this.state.vodVariantMax}
                                                onChange={(event, data) => this.setVariantMax(event, oauth.sys.licenseFlowLimit, data)}
                                                error
                                                placeholder={oauth.sys.licenseFlowLimit ? oauth.sys.licenseFlowLimit > 64 ? 64 : oauth.sys.licenseFlowLimit : 64}
                                            />
                                            {this.state.vodVariantMax > (oauth.sys.licenseFlowLimit ? oauth.sys.licenseFlowLimit > 64 ? 64 : oauth.sys.licenseFlowLimit : 64) ?
                                                <Label className="right-align-label-red">
                                                    Value needs to be {oauth.sys.licenseFlowLimit ? oauth.sys.licenseFlowLimit > 64 ? 64 : oauth.sys.licenseFlowLimit : 64} or less.
                                                </Label>
                                                : '' }
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Maximum simultaneous assets
                                            </Label>
                                            <Input
                                                type="number"
                                                min="1"
                                                max="500"
                                                value={this.state.vodAssetMax}
                                                onChange={(e: any, data: any) => this.setState({vodAssetMax: data.value})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                                <Segment className="segment-header">Partial Blocks File Mode</Segment>
                                <Segment>
                                    <Form>
                                        <span>
                                            <p>Values are used for VOD Assets configured to test using File Mode, ‘Partial’. Define the
                                            percentage of the asset beginning, middle, and end to be tested.
                                            </p><br />
                                        </span>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Beginning (percent)
                                            </Label>
                                            <Input
                                                type="number"
                                                min="0"
                                                max="25"
                                                value={this.state.vodPartialBegin}
                                                onChange={(e: any, data: any) => this.setState({vodPartialBegin: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Middle (percent)
                                            </Label>
                                            <Input
                                                type="number"
                                                min="0"
                                                max="25"
                                                value={this.state.vodPartialMiddle}
                                                onChange={(e: any, data: any) => this.setState({vodPartialMiddle: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                End (percent)
                                            </Label>
                                            <Input
                                                type="number"
                                                min="0"
                                                max="25"
                                                value={this.state.vodPartialEnd}
                                                onChange={(e: any, data: any) => this.setState({vodPartialEnd: data.value})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                                <Segment className="segment-header">
                                    <span>Timeouts </span>
                                    <Modal
                                        closeIcon
                                        onClose={() => this.setTimeoutHelpModalOpen(false)}
                                        onOpen={() => this.setTimeoutHelpModalOpen(true)}
                                        open={this.state.timeoutHelpModalOpen}
                                        size="small"
                                        trigger={<Icon name="question circle" size="small" />}
                                    >
                                        <Header as="h5" icon className="speedModalHeader">
                                            Timeouts
                                        </Header>
                                        <Modal.Content>
                                            <p>
                                                {/* tslint:disable-next-line:max-line-length */}
                                                <b>Outage</b> - Stops stream test when outage condition exceeds configured value. Stream test will be marked as an Outage timeout error. Setting this value allows the test to be failed and move monitoring resources to other tests.
                                            </p>
                                            <p>
                                                <b>Stream Advance</b> – Setting is applicable for tests in time or file advance modes. If test time exceeds the configured value, the test will be stopped and marked as a Stream Advance timeout error.
                                                This threshold prevents continuing to run tests that are being impacted by slow network delivery conditions.
                                            </p>
                                            <p>
                                                {/* tslint:disable-next-line:max-line-length */}
                                                <b>Full Stream Deviation</b> – Setting is applicable for tests in ‘All’ segments mode. If the test time exceeds the stream’s duration by the configured percentage, the stream will be stopped and marked as Full Stream timeout error.
                                            </p>
                                        </Modal.Content>
                                    </Modal>
                                </Segment>
                                <Segment>
                                    <Form>
                                        <span>
                                            <p>Configured timeouts allow monitoring to proceed during outage and slow network delivery conditions.</p><br />
                                        </span>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Outage (minutes)
                                            </Label>
                                            <Input
                                                maxLength={9}
                                                className="system-config-segment-input"
                                                value={this.state.vodTimeoutOutage}
                                                onChange={(e: any, data: any) => this.setState({vodTimeoutOutage: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Stream Advance (minutes)
                                            </Label>
                                            <Input
                                                maxLength={9}
                                                className="system-config-segment-input"
                                                value={this.state.vodTimeoutAdvance}
                                                onChange={(e: any, data: any) => this.setState({vodTimeoutAdvance: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Full Stream Deviation (percent deviation)
                                            </Label>
                                            <Input
                                                maxLength={9}
                                                className="system-config-segment-input"
                                                value={this.state.vodTimeoutFullDev}
                                                onChange={(e: any, data: any) => this.setState({vodTimeoutFullDev: data.value})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                                <Segment className="segment-header">Media Files Duration</Segment>
                                <Segment>
                                    <Form>
                                        <span>
                                            <p>
                                                If media content exceeds the defined duration on the VOD Asset Alias configuration by more than the configured deviation percentage, a Duration error will be indicated.
                                            </p><br />
                                        </span>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Duration Deviation (percent)
                                            </Label>
                                            <Input
                                                type="number"
                                                min="0"
                                                max="100"
                                                value={this.state.vodDurDev}
                                                onChange={(e: any, data: any) => this.setState({vodDurDev: data.value})}
                                            />
                                        </Form.Group>

                                    </Form>
                                </Segment>
                            </Segment.Group>
                        </div>
                    </React.Fragment>
                   );
                }}
            </OAuth.Context>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/monitoring/vodConfig.tsx